import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"

import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Alert,
  Card,
  CardBody
} from "shards-react"

import { StaticImage } from "gatsby-plugin-image"
import { isMobile } from "react-device-detect"
import Switcher from "../components/switcher"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

// Images & Video Resources
import StudentVideo from "../videos/sat.mp4"
import SATBanner from "../images/sat-banner.jpeg"

// Internal JavaSript libraries
import { getCountry } from "../js/getCountry"
import { routify } from "../js/routify"

class CSEC extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      // Import the routes for the country
      routes: require("../data/routes.json"),
      country: getCountry(this.props.pageContext.countryCode || "JM")
    }
  }

  render() {
    const Video = () => (
      <video
        style={{ width: "100%" }}
        preload="auto"
        autoPlay={true}
        loop
        muted
      >
        <source src={StudentVideo} type="video/mp4" />
      </video>
    )

    const NoticeItem = props => (
      <>
        <br />
        <Card>
          <CardBody>
            <h6>{props.title}</h6>
            <p>{props.description}</p>
          </CardBody>
        </Card>
      </>
    )

    const Notices = () => (
      <div>
        <h5 className="text-primary">SAT Update Center</h5>

        {this.props.pageContext.notices ? (
          this.props.pageContext.notices.map(notice => (
            <NoticeItem
              key={notice.id}
              title={notice.title}
              description={notice.description}
            />
          ))
        ) : (
          <p>No updates available</p>
        )}
      </div>
    )

    return (
      <Layout countryCode={this.props.pageContext.countryCode || "JM"}>
        <Seo
          countryCode={this.props.pageContext.countryCode || "JM"}
          title={this.props.pageContext.name || "SAT Programme"}
          description=""
        />

        <MobileView>
          <Video />
        </MobileView>

        <Container>
          <Breadcrumb>
            <BreadcrumbItem>
              <a href="/">Home</a>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <a
                href={routify(
                  this.state.country.slug,
                  this.state.routes.programmes
                )}
              >
                Programmes
              </a>
            </BreadcrumbItem>
            <BreadcrumbItem active>SAT</BreadcrumbItem>
          </Breadcrumb>

          <h3>{this.props.pageContext.name || "SAT Programme"}</h3>

          <p>
            The SAT is an entrance exam used by most colleges and universities
            to make admissions decisions. The SAT is a multiple-choice,
            pencil-and-paper test created and administered by the College Board
            {this.state.country.countryCode
              ? " and in " + this.state.country.name
              : "."}
            .
          </p>

          <Row>
            <Col md={6}>
              <Row className="text-center">
                <Col xs={6}>
                  <a
                    target="_blank"
                    href="https://satsuite.collegeboard.org/sat/scores/sat-score-release-dates"
                  >
                    <Alert theme="primary">Score Dates</Alert>
                  </a>
                </Col>
                <Col xs={6}>
                  <a href="">
                    <Alert theme="success">Exam FAQs</Alert>
                  </a>
                </Col>
                <Col xs={12}>
                  <a href={this.state.routes.satApply}>
                    <Alert theme="light">Apply Now</Alert>
                  </a>

                  <p>
                    <a
                      href={routify(
                        this.state.country.countryCode,
                        this.state.routes.chat
                      )}
                      className="text-center text-primary pb-2"
                    >
                      Speak with an Enrollment Officer
                    </a>
                  </p>
                </Col>
              </Row>

              <p className="pt-2">
                Registration for our 3-month online SAT classes are now open.
                Classes begin{" "}
                {this.props.pageContext.startDate || "May 9, 2022"}. Enrolled
                students will receive
              </p>

              <ul>
                <li>3-4 hours of class time weekly for each subject</li>
                <li style={{ paddingTop: "10px" }}>Weekly assignments</li>
                <li style={{ paddingTop: "10px" }}>Monthly mock exams</li>
                <li style={{ paddingTop: "10px" }}>
                  Monthly progress reports for parents
                </li>
                <li style={{ paddingTop: "10px" }}>Virtual textbooks</li>
                <li style={{ paddingTop: "10px" }}>
                  Additional virtual class materials
                </li>
              </ul>

              <br />
              <Alert
                theme="primary"
                className={isMobile ? "break-container" : ""}
              >
                <br />
                <h5 className="text-light">Tuition & Fees</h5>

                <p>
                  The cost of the course is{" "}
                  {this.props.pageContext.cost || "$400 USD"}. This covers both
                  your tuition and examination fee.
                </p>

                <p>
                  <i class="fa-solid fa-circle-info pr-2"></i>
                  $20 USD non-refundable registration fee.
                </p>

                <br />
              </Alert>
            </Col>
            <Col md={6}>
              <BrowserView>
                <Video />
              </BrowserView>

              <br />
              <Notices />

              <br />
              <br />
              <h5>Resources</h5>
              <p>No resources available</p>
            </Col>
          </Row>
        </Container>

        <MobileView>
          <br />
          <br />
          <StaticImage
            src={"../images/sat-banner.jpeg"}
            style={{ width: "100%" }}
          />
        </MobileView>
      </Layout>
    )
  }
}

export default CSEC
